<template>
  <div id="notificationModal" ref="notificationModal" class="modal fade" tabindex="-1"
    aria-labelledby="notificationModal" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-5">
          <div
            class="relative w-full mobile:h-[70px] tablet:h-[80px] rounded-lg overflow-hidden flex items-center justify-start">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <img src="../../assets/images/profile-bg.png" class="w-full object-contain absolute left-0 top-0"
                alt="backgroundImage">
              <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12">
                <h6 class="m-0 text-xl font-roboto font-normal text-black-100">
                  Notifications
                </h6>
              </div>
            </div>
          </div>
          <div
            class="responsiveOreitationHeightAdjust customScrollbar overflow-y-auto mt-[20px] px-[10px] tablet:px-0 pb-[10px] tablet:pb  -0"
            @scroll="handleScroll">
            <div :class="customClass">
              <ul v-if="grouped.latest.length" class="my-3 p-0">
                <li v-for="(n, i) in grouped.latest" :key="'recent-' + i" class="mb-2"
                  :class="{ 'cursor-pointer': notificationRoute(n) }" @click="openNotification(n, $event)">
                  <!-- record notifications: real <a href> (open in new tab); others stay a plain row -->
                  <component :is="notificationLink(n) ? 'router-link' : 'div'" :to="notificationLink(n) || undefined"
                    class="flex gap-3 items-start no-underline text-inherit">
                    <img :src="n.sender_profile_image ? n.sender_profile_image : generateAvatar(n.sender_full_name)"
                      alt="" class="w-[40px] h-[40px] rounded-full object-cover">
                    <div class="pb-2 border-b-[1px] border-[#EFEFEF]">
                      <p class="mt-0 mb-1 font-roboto text-[15px] text-[#666666]">
                        {{ n.message }}
                      </p>
                      <div class="m-0 text-[14px] font-roboto flex gap-2 items-center text-[#C2C2C2]">
                        <div class="flex w-[14px] flex-shrink-0 text-[#999] -translate-y-px"><svg
                            xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 36 36"
                            aria-hidden="true">
                            <path d="M0 0h36v36H0z" fill="none" />
                            <path fill="currentColor"
                              d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2m0 30a14 14 0 1 1 14-14a14 14 0 0 1-14 14" />
                            <path fill="currentColor"
                              d="M18.92 18.4v-7.65a1 1 0 0 0-2 0v8.72l5.9 4a1 1 0 1 0 1.11-1.66Z" />
                            <path fill="currentColor"
                              d="M8 17.94a9.94 9.94 0 0 1 15.41-8.35l.85-1.36a11.55 11.55 0 1 0-8.53 21L16 27.7a10 10 0 0 1-8-9.76" />
                          </svg></div>
                        <span class="text-[14px] font-roboto">{{ $helper.getTimeAgo(n.datetime) }}</span>
                      </div>
                    </div>
                  </component>
                </li>
              </ul>

              <div v-if="grouped.lastMonth.length">
                <p class="font-roboto text-[12px] text-[#999999]">
                  Last Month
                </p>
                <ul class="my-3 p-0">
                  <li v-for="(n, i) in grouped.lastMonth" :key="'last-' + i" class="mb-2"
                    :class="{ 'cursor-pointer': notificationRoute(n) }" @click="openNotification(n, $event)">
                    <!-- record notifications: real <a href> (open in new tab); others stay a plain row -->
                    <component :is="notificationLink(n) ? 'router-link' : 'div'" :to="notificationLink(n) || undefined"
                      class="flex gap-3 items-start no-underline text-inherit">
                      <img :src="n.sender_profile_image ? n.sender_profile_image : generateAvatar(n.sender_full_name)"
                        alt="" class="w-[40px] h-[40px] rounded-full object-cover">
                      <div class="pb-2 border-b-[1px] border-[#EFEFEF]">
                        <p class="mt-0 mb-1 font-roboto text-[15px] text-[#666666]">
                          {{ n.message }}
                        </p>
                        <div class="m-0 text-[14px] flex gap-2 items-center text-[#C2C2C2]">
                          <div class="flex w-[14px] flex-shrink-0 text-[#999] -translate-y-px"><svg
                              xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 36 36"
                              aria-hidden="true">
                              <path d="M0 0h36v36H0z" fill="none" />
                              <path fill="currentColor"
                                d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2m0 30a14 14 0 1 1 14-14a14 14 0 0 1-14 14" />
                              <path fill="currentColor"
                                d="M18.92 18.4v-7.65a1 1 0 0 0-2 0v8.72l5.9 4a1 1 0 1 0 1.11-1.66Z" />
                              <path fill="currentColor"
                                d="M8 17.94a9.94 9.94 0 0 1 15.41-8.35l.85-1.36a11.55 11.55 0 1 0-8.53 21L16 27.7a10 10 0 0 1-8-9.76" />
                            </svg></div>
                          <span class="text-[14px] font-roboto">{{ $helper.getTimeAgo(n.datetime) }}</span>
                        </div>
                      </div>
                    </component>
                  </li>
                </ul>
              </div>

              <EmptyState v-if="!grouped.latest.length && !grouped.lastMonth.length" title="No notifications" text=""
                min-height="min-h-[200px]" />

              <div v-if="loading" class="text-center p-4">
                <span>Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { globals } from "../../main";
import { isNewTabClick } from "@/helpers/newTabClick";
import EmptyState from "@/components/partialComponent/EmptyState.vue";
export default {
  components: { EmptyState },
  props: ["openPopup", "customClass"],
  emits: ["closed"],
  data() {
    return {
      notifications: [],
      page: 1,
      totalPages: 1,
      loading: false,
      listenersBound: false,
      // set by the bell click; a late notifications/list response must not pop the modal open on another page
      wantOpen: false
    };
  },
  computed: {
    ...mapGetters(["notificationResponse"]),
    grouped() {
      const latest = [];
      const lastMonth = [];

      this.notifications.forEach(item => {
        const date = new Date(item.datetime);

        const now = new Date();

        const isThisMonth =
          date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();

        if (isThisMonth) {
          latest.push(item);
        } else {
          lastMonth.push(item);
        }
      });

      return { latest, lastMonth };
    }
  },

  watch: {
    notificationResponse(newVal) {
      if (newVal) {
        globals.$loader.hide();
        this.loading = false
        this.notifications.push(...newVal.body);
        this.totalPages = newVal.paging.total_pages;
        this.page++;

        if (this.wantOpen) {
          this.wantOpen = false
          this.notificationModal()
        }
      }
    },

    // left the page before the list came back: don't open the modal there
    "$route.fullPath"() {
      if (this.wantOpen) {
        this.wantOpen = false
        globals.$loader.hide();
      }
    },

    openPopup(newVal) {
      this.notifications = [],
        this.page = 1,
        this.totalPages = 1,
        this.loading = false
      this.wantOpen = true
      globals.$loader.show();
      this.getNotifications()
    },
  },

  mounted() {

  },
  methods: {
    ...mapActions(["fetchNotifications"]),

    getNotifications() {
      if (this.loading || this.page > this.totalPages) return;
      this.loading = true;
      try {
        this.fetchNotifications({
          limit: 20,
          page: this.page
        })
      } catch (err) {
        console.error(err);
      } finally {
        // this.loading = false;
      }

    },

    handleScroll(event) {
      const el = event.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
        console.log("AAAA");

        this.getNotifications();
      }
    },

    adjustModalHeightNotification() {
      const modalContent = this.$refs.notificationModal?.querySelector('.responsiveOreitationHeightAdjust');
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 768) {
          // Mobile devices
          maxHeight = vh * 0.7 - 40; // 90% of viewport height minus some padding
        } else if (vw < 1024) {
          // Tablets
          maxHeight = vh * 0.5 - 30;
        } else {
          // Desktops
          maxHeight = vh * 0.8 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },


    notificationModal() {
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.notificationModal;
      let modal = Modal.getInstance(modalEl);
      if (!modal) {
        modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      // same function refs, so re-adding is a no-op while they are attached
      window.addEventListener('resize', this.adjustModalHeightNotification);
      window.addEventListener('orientationchange', this.adjustModalHeightNotification);
      // Add event listeners for show/hide (once — this runs on every page of results)
      if (this.listenersBound) {
        modal.show();
        return;
      }
      this.listenersBound = true;
      modalEl.addEventListener('show.bs.modal', () => {
        document.documentElement.style.overflow = 'hidden'; // Target HTML element
        if (window.innerWidth >= 992) {
          document.documentElement.style.paddingRight = '15px';
        } else {
          document.documentElement.style.paddingRight = '0px';
        }

        this.$nextTick(() => {
          const scrollable = modalEl.querySelector('.responsiveOreitationHeightAdjust');
          if (scrollable) scrollable.scrollTop = 0;
        });

        this.adjustModalHeightNotification();
      });
      modalEl.addEventListener('hidden.bs.modal', () => {
        this.$emit('closed');
        document.documentElement.style.overflow = ''; // Reset HTML element
        document.documentElement.style.paddingRight = '0px';
        window.removeEventListener('resize', this.adjustModalHeightNotification);
        window.removeEventListener('orientationchange', this.adjustModalHeightNotification);
      });
      modal.show();
    },

    // Android NotificationFragment.setClickActions / selectedRowItemNavigation: the notification `type`
    // prefix picks the screen, payload.data.<booking|order|manual_quote|appointment>.id the record
    notificationRoute(n) {
      let payload = n?.payload;
      if (typeof payload === 'string') {
        try { payload = JSON.parse(payload) } catch (e) { payload = null }
      }
      const data = payload?.data ?? {};
      const type = String(n?.type ?? '').toUpperCase();
      const route = (name, obj) => (obj && obj.id ? { name, params: { id: obj.id } } : null);

      if (type.startsWith('BOOKING')) return route('job-detail', data.booking);
      // ORDER and ORDER_NOTES (Android opens the order notes screen; notes live on the RQ detail here)
      if (type.startsWith('ORDER')) return route('rq-detail', data.order);
      if (type.startsWith('MANUAL_QUOTE')) return route('QuoteDetail', data.manual_quote);
      // APPOINTMENT_BROADCAST and APPOINTMENT both end on the appointment detail
      if (type.startsWith('APPOINTMENT')) return route('AppointmentDetail', data.appointment);
      if (type.startsWith('GS_VALIDATE_MERCHANT') && data.training_url) return { url: data.training_url };
      return null;
    },

    // in-app record → route location for <router-link>; external (url) / no record → null
    notificationLink(n) {
      const target = this.notificationRoute(n);
      return target && !target.url ? target : null;
    },

    openNotification(n, e) {
      const target = this.notificationRoute(n);
      if (!target) return;
      // Ctrl/Cmd/middle click on the link opens a new tab: keep the panel open
      if (!target.url && isNewTabClick(e)) return;
      const { Modal } = require('bootstrap');
      Modal.getInstance(this.$refs.notificationModal)?.hide(); // 'hidden' → emits closed
      if (target.url) {
        window.open(target.url, '_blank', 'noopener');
      } else if (!(e && e.target && e.target.closest && e.target.closest('a'))) {
        // a click on the <a> is navigated by router-link
        this.$router.push(target);
      }
    },

    generateAvatar(name) {
      const initials = name
        .split(" ")
        .map(n => n[0])
        .join("")
        .toUpperCase();
      return `https://ui-avatars.com/api/?name=${initials}&background=random&color=fff&size=64`;
    }
  }
};
</script>